/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { memo } from 'react';
import { ActivityIndicator } from 'react-native';
import {} from 'react-native-redash';

export const TaskNavBarSpinner = memo(
  ({ animating, offsetX }: { animating?: boolean; offsetX: number }) => (
    <ActivityIndicator
      color="#fff"
      size="small"
      animating={animating}
      style={{
        transform: [{ scale: 0.8 }, { translateY: 2 }, { translateX: offsetX }],
      }}
    />
  ),
);
